import { type DependencyList, useCallback, useEffect, useRef, useState } from 'react'

export const useInterval = (callback: () => void, delay: number, dependencies: DependencyList = []) => {
  const savedCallback = useRef(callback)
  const [isActive, setIsActive] = useState(true)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  const reset = useCallback(() => {
    setIsActive(false)
    setTimeout(() => setIsActive(true), 0)
  }, [])

  useEffect(() => {
    if (!isActive) return

    const id = setInterval(() => savedCallback.current(), delay)
    return () => clearInterval(id)
  }, [delay, isActive])

  useEffect(() => {
    reset()
  }, [...dependencies, reset])

  return reset
}
